module.exports = __webpack_public_path__ + "images/frontpage_infinite@1x.png?30326aa4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_infinite@1x.png
// module id = 651
// module chunks = 7